<template>
  <div>
    <div v-if="registering">
      <div class="tw-text-3xl tw-text-center tw-font-semibold">Join pocstock</div>
      <div class="tw-mt-6">
        <b-form-group label="Email" label-class="text-truncate label-required">
          <b-form-input v-model="email" required placeholder="Your email address" :state="hasError('email')"/>
          <b-form-invalid-feedback v-html="errors.email"/>
        </b-form-group>

        <b-form-group label="Company name" label-class="text-truncate">
          <b-form-input v-model="company_name" required placeholder="Your company name"
                        :state="hasError('company_name')"/>
          <b-form-invalid-feedback v-html="errors.company_name"/>
        </b-form-group>

        <b-form-group label-class="text-truncate label-required">
          <template v-slot:label>
            Password
            <a href="#" class="tw-ml-2" v-b-popover.hover.top="popoverText">
              <i class="fas fa-question-circle"></i>
            </a>
          </template>

          <b-form-input v-model="password" type="password" required placeholder="Create your password"
                        :state="hasError('password')"/>
          <b-form-invalid-feedback v-html="errors.password"/>
        </b-form-group>

        <b-form-group label="Confirm password" label-class="text-truncate label-required">
          <b-form-input v-model="password_confirmation" type="password" required placeholder="Confirm your password"
                        :state="hasError('password_confirmation')"/>
          <b-form-invalid-feedback v-html="errors.password_confirmation"/>
        </b-form-group>
      </div>

      <p>
        <b-form-checkbox v-model="acceptedTerms" required>
          By creating an account, you agree to POCSTOCK's <a href="/terms" target="_blank">Terms of Service</a> and <a
          href="legal/privacy" target="_blank">Privacy Policy</a>.
        </b-form-checkbox>
      </p>

      <b-button :disabled="loading || !acceptedTerms"
                @click="createAccount" variant="primary" class="tw-mt-5 tw-w-full btn-rounded">
        Send email verification
      </b-button>
    </div>
    <div v-else>
      <div class="tw-flex tw-justify-end">
        <button class="btn-reset" @click="$emit('close')">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="tw-py-10 tw-flex tw-flex-col tw-items-center tw-justify-center">
        <img :src="thankYouImage" alt="thank you"/>
        <div class="tw-text-3xl tw-text-center tw-font-semibold tw-mt-6">Verification Email Sent!</div>
        <div class="tw-text-center tw-mt-4">
          <div>An email has been sent to verify and complete your account registration.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {UsersApi} from "../../Api/UsersApi.js";
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import AssetLoader from "../../../../AssetLoader.js";

export default {
  mixins: [GeneralMixins],
  data() {
    return {
      registering: true,
      email: "",
      password: "",
      password_confirmation: "",
      company_name: "",
      loading: false,
      acceptedTerms: false,
      errors: {
        email: null,
        password: null,
        password_confirmation: null,
        company_name: null
      }
    }
  },

  computed: {
    thankYouImage() {
      return AssetLoader.imagePath("congrats.png")
    },

    popoverText() {
      return {
        content: "Your password must be at least 8 characters in length, and contain at least 1: uppercase, lowercase, and symbol.<br/><a href='https://www.lastpass.com/password-generator' target='_blank'>Strong Password Generator</a>",
        html: true
      }
    },

    params() {
      return {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        company_name: this.company_name,
        sign_up_role: "customer"
      }
    }
  },

  methods: {
    resetErrors() {
      this.errors = {
        email: null,
        password: null,
        password_confirmation: null,
        company_name: null
      }
    },

    resetForm() {
      this.email = ""
      this.password = ""
      this.password_confirmation = ""
      this.company_name = ""
    },

    hasError(field) {
      if (this.errors[field]) {
        return false
      } else {
        return null
      }
    },
    async createAccount() {
      this.resetErrors()
      this.loading = true
      try {
        await UsersApi.register(this.params)
        this.resetForm()
        this.registering = false
      } catch (error) {
        const keys = Object.keys(error.body)
        for (const key of keys) {
          this.errors[key] = error.body[key].join("<br/>")
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
